// node_modules
import 'promise-polyfill/src/polyfill.js';
import 'custom-event-polyfill';
import 'url-search-params-polyfill';
import 'string.prototype.startswith';

// vendored and custom polyfills
import 'lib/event_func_constructor_polyfill.js';
import 'lib/math_sign_polyfill.js';



// WEBPACK FOOTER //
// ./app/javascript/globals/polyfills.js